import { useContext, useState } from "react";
import { IAxiosError } from "../../../../../utils";
import { AvisSection } from "../../../../shared/components/form";
import { AvisContext } from "../../../../shared/context/AvisContext";
import { ErrorLoadingDataHoc } from "../../../../shared/error/ErrorLoadingDataHoc";
import { InvoicesArchiveGrid } from "../../../invoices/components/InvoicesArchiveGrid";
import { InvoicesGrid } from "../../../invoices/components/InvoicesGrid";

export function LicenseInvoices() {
  const { res } = useContext(AvisContext);
  const [error, setError] = useState<IAxiosError>();

  return (
    <ErrorLoadingDataHoc error={error}>
      <AvisSection
        title={res("licensees_Invoices_PageTitle_actual")}
        textToDisplayKey="portal_LIC_LicenseInvoices"
      >
        <InvoicesGrid setError={setError} />
      </AvisSection>
      <AvisSection
        title={res("licensees_Invoices_PageTitle_archive")}
        textToDisplayKey="portal_LIC_LicenseInvoiceArchive"
      >
        <InvoicesArchiveGrid setError={setError} />
      </AvisSection>
    </ErrorLoadingDataHoc>
  );
}
